import React from 'react'
import axios from 'axios'
import Moment from 'moment';
import {
  Button,
  Card,
  Modal,
  Col,
  Form,
  Icon,
  Input,
  Option,
  Dropdown,
  Select,
  Row,
  Menu,
  message,
  TimePicker,
  DatePicker,
  Switch,
  Cascader,
  notification,
} from 'antd'
import {connect} from 'react-redux'
import {decode} from 'utf8'
import {updateStatusOrder, fetchOrders} from 'appRedux/actions/Orders'

const FormItem = Form.Item


const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

const text = "Estado";
const AUTH_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8'


class Basic extends React.Component {
  state = {
    visible: false,
    id: '',
    date:'',
    hour:'',
    status: '', 
    validateStatus:'',
  }


  handleChangeType = value => {
    console.collection_date
    this.setState({
      status: value,
    })
  }

  showModal = () => {
    this.setState({
      visible: true,
      id: this.props.recording.id,
      status:this.props.recording.status
    })
  }

  handleCancel = e => {
    this.setState({
      id: '',
      date:'',
      hour:'',
      status: '',
    })
   this.props.fetchOrders(this.props.dataState)
    this.setState({visible: false})
  }



  showdetails = id => {
    axios({
      method: 'get',
      url: `https://admingreenerapp.crsostenible.com/api/public/api/app/order_collection/get/${id}`,
      headers:{
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + AUTH_TOKEN
      }
    })
    //.then(request => console.log(request.data))
  .then((request) => {
    
    if(request.data.collection_date=="1995-12-31" ||request.data.collection_date=="0000-00-00"  || request.data.collection_date==null){
      this.setState({hour:"00:00",date: Moment().format("YYYY-MM-01")})
    }else{
      this.setState({hour: request.data.collection_time,date:request.data.collection_date})

    }
    
    
    console.log('res',this.state)
  })
  .catch(error => alert(error.message))
  }




  onNotification = (type, value) => {
    if (type == 'success') {
      notification[type]({
        message: 'Éxito',
        description: value || 'Agregado los datos con éxito.',
      })
    } else {
      notification[type]({
        message: 'Error',
        description: value || 'Ha ocurrido al agregar los datos del pedido.',
      })
    }
  }

  onHandleClick = event => {
    event.preventDefault()
    let {id, date, hour, status} = this.state
    console.log('state-->>>',this.state)
      if (id && date && hour && status != "") {

      this.props.updateStatusOrder(this.state)
      this.props.fetchOrders(this.props.dataState)
      this.onNotification('success', 'La orden se ha editado con éxito')
      } else {
        this.onNotification(
          'error',
          'Rellene los campos obligatorios',
        )
      }
     
  }

  TimeInfo=(time, timeString)=> {
    console.log(timeString)
    this.setState({hour: timeString});
  }
    
  DateInfo = (date, dateString) => {
    console.log(dateString)
    this.setState({date: dateString})
  }


  render() {
    return (
      <div>
        <Button className="ant-btn-yellow" onClick={ () => {
        this.showModal()
        this.showdetails(this.props.recording.id)
        console.log(this.props)
        console.log('my state',this.props.recording.address_description)
        }} style={{backgroundColor:'#FFCC00!important'}}>
        Coordinar
        </Button>
        <Modal
          afterClose={() =>   this.props.fetchOrders(this.props.dataState)}
          okText="Editar"
          cancelText="Salir"
          title=""
          visible={this.state.visible}
          onOk={this.onHandleClick}
          onCancel={this.handleCancel}
        >
          <Card className="gx-card" title="Editar pedido">
            <form onSubmit={this.onHandleClick}>
            <Row className="padding-modal">
            <Col lg={8} md={8} sm={8} xs={8}> 
                  <FormItem
                    label="Fecha de entrega:"
                  >
                  </FormItem>
                 </Col>
                 <Col lg={16} md={16} sm={16} xs={16}>
              
                    <DatePicker value={Moment(this.state.date,'YYYY-MM-DD')} onChange={this.DateInfo} placeholder="Selecciona una fecha"/>
                </Col>

                <Col lg={8} md={8} sm={8} xs={8}> 
                  <FormItem
                    label="Hora de entrega:"
                  >
                  </FormItem>
                 </Col>
                 <Col lg={16} md={16} sm={16} xs={16}>
                 
                     <TimePicker format="HH:mm" value={Moment(this.state.hour,'HH:mm')}  onChange={this.TimeInfo} placeholder="Hora"/>
                </Col>


              </Row>
            </form>
          </Card>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps({placeStores, orders}) {
  return {
    placeStores,
    orders,
  }
}
export default connect(
  mapStateToProps,
  {updateStatusOrder, fetchOrders},
)(Basic)



// WEBPACK FOOTER //
// ./src/routes/main/Orders/DateHour.js